import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Rx';
import { PagerService } from '../../../../common/services/Pagination.service';
import { ModalInfoService } from '../../../../common/services/ModalInfo.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

import * as _ from 'lodash';
import { ContactService } from '../../../../common/services/Contact.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'contacts',
  templateUrl: './contacts.template.html',
  styleUrls: ['../../../../../css/fuck.css', './contact.css'],
  providers: [EvsAddressService, BsModalService],
})
@Injectable()
export class ContactsComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public pager: any = {};
  public message: { class: string; content: string } = null;
  public msgs: Message[] = [];
  public error = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public list: any = [];
  public paramsQuery: any = {};

  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public allSource: Array<any> = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;

  public arr_sort: any = { name: null };
  public id_delete: any;
  public modalRef2: any;

  isSorting: any = {};
  isAdd: Boolean = false;
  isUpdate: Boolean = false;

  totalItem: any = 0;
  totalPage: any = 0;

  constructor(
    private _location: Location,
    private router: Router,
    private contactService: ContactService,
    private pagerService: PagerService,
    public addressService: EvsAddressService,
    private mdInfo: ModalInfoService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();
    const that = this;
    $('#city').select2({ placeholder: '-- Tỉnh/TP --', allowClear: false });
    $('#district').select2({
      placeholder: '-- Quận/Huyện --',
      allowClear: false,
    });
    $('#sex').select2({ placeholder: '-- Giới tính --', allowClear: false });
    $('#source').select2({
      placeholder: '-- Nguồn khởi tạo --',
      allowClear: false,
    });

    $('#city').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      const id = e.target.value;
      that.loadDistrictData(id);
    });
    $('#district').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });

    $('#source').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });

    // this.clearDataForm();
    this.getCity();
    this.loadData();
    this.getSource();
    this.setSort('created_at', 'desc');
    this.isSorting['field'] = 'created_at';
    this.isSorting['typeSort'] = 'desc';
  }

  getSource() {
    this.allSource = [
      {
        value: 'call',
        label: 'Gọi điện',
        id: 'call',
      },
      {
        value: 'chat',
        label: 'Chat',
        id: 'chat',
      },
      {
        value: 'facebook',
        label: 'Facebook',
        id: 'facebook',
      },
      {
        value: 'hand',
        label: 'Thêm mới',
        id: 'hand',
      },
    ];
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then(res => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }
    request.field = '_id, name, city,phone,email, sex, facebook';
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    delete request.desc;
    delete request.asc;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.contactService
      .list(request)
      .toPromise()
      .then(
        res => {
          this.loading_data = false;
          if (res.status == 200 && res.error == false) {
            this.totalRow = res.data.total;
            this.list = res.data.contacts;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;

            if (this.list.length > 0) {
              this.item_detail = this.viewDetail(0);
              this.item_active = 0;
            }
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  viewDetail(i) {
    if (this.isAdd == true) {
      this.toastr.info('Thao tác tạo mới khách hàng đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (this.isUpdate == true) {
      this.toastr.info('Thao tác cập nhật khách hàng đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    this.isAdd = false;
    this.isUpdate = false;
    this.item_active = i;
    this.contactService
      .find(this.list[i]._id)
      .toPromise()
      .then(rs => {
        this.item_detail = rs.data;
        if ((this.item_detail.sex = 'female')) {
          this.item_detail.sex = 'Nữ giới';
        }
        if ((this.item_detail.sex = 'male')) {
          this.item_detail.sex = 'Nam giới';
        }
        if ((this.item_detail.sex = 'other')) {
          this.item_detail.sex = 'Khác';
        }
        if (this.item_detail.birthday) {
          this.item_detail.birthday = moment(this.item_detail.birthday).format('DD-MM-YYYY');
        }
      });
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery);
    }
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.contactService.deleteContact(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Thực hiện xóa của bạn không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Bạn đã xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
          }
          // this.modalRef2.hide();
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  resetForm(frm: NgForm) {
    $('#city').val('').trigger('change');
    $('#district').val('').trigger('change');
    $('#sex').val('').trigger('change');
    frm.reset();
    this.loadData();
  }

  onSubmit() {
    this.item_active = 0;
    const modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }

    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }

    if (this.model.email) {
      modelQuery.email = this.model.email;
    }
    if ($('#sex').val()) {
      modelQuery.sex = $('#sex').val().toString();
    }
    if ($('#city').val()) {
      const city = $('#city option:selected').val();
      modelQuery.city_id = city;
    }
    if ($('#district').val()) {
      const district = $('#district option:selected').val();
      modelQuery.district_id = district;
    }

    if ($('#source').val()) {
      modelQuery['source_detail'] = $('#source').val();
    }

    this.currentPage = 1;
    this.loadData(modelQuery);
  }

  checkAll() {
    if ($('#td-checkbox-main').is(':checked')) {
      $('input.td-checkbox').prop('checked', true);
    } else {
      $('input.td-checkbox').prop('checked', false);
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); // currentPage start from: 0
    }
  }

  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  searchByName(event, mode?: any) {
    if (event.keyCode == 13) {
      if (this.model.name.trim().length > 0) {
        this.router.navigate([], {
          queryParams: this.model,
        });
      }
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  redirectUpdate() {
    this.isAdd = false;
    this.isUpdate = true;
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }
  setSort(field: string, typeSort: string) {
    this.currentPage = 1;
    if (this.isSorting['field'] !== field || this.isSorting['typeSort'] !== typeSort) {
      this.isSorting['field'] = field;
      this.isSorting['typeSort'] = typeSort;
      this.loadData(null, { field: field, typeSort: typeSort });
    }
  }
  addContact() {
    this.isAdd = true;
    this.isUpdate = false;
  }
  backToComponent(event) {
    this.isAdd = false;
    this.isUpdate = false;
    if (event.isBack == false) {
      this.currentPage = 1;
      this.loadData(null, this.isSorting);
    }
  }
  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/contact/contacts.component.ts